export default __webpack_public_path__ + "static/media/11-50.1043d7e5.jpeg";